<template>
  <article class="content-page">
    <h1 class="heading">CONTACT</h1><br>
    <img :src="require('@/assets/images/email.png')">
  </article>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

